export default __webpack_public_path__ + "static/media/books2-afterA-1920w.d28cdd58.png";